export enum TMS_EQUIPMENT {
  '53_van' = "53' Van",
  '48_van' = "48' Van",
  'dry_van' = 'Dry Van',
  'open_deck' = 'Flatbed',
  'reefer' = 'Reefer',
  '53_reefer' = "53' Reefer",
  '48_reefer' = "48' Reefer",
  '53_flatbed' = "53' Flatbed",
  '48_flatbed' = "48' Flatbed",
  stepdeck = 'Stepdeck',
  'container' = 'Container',
  'mixed_unspecified' = 'Mixed / Unspecified',
}

// This is for Shipments lists display
// New shipments being created
// are being created with children value , 53_van
// so response return 53_van
// But there are shipments that
// have been made with dry_van in the response
export enum EQUIPMENT_KEY {
  '53_van' = 'Dry Van',
  '48_van' = 'Dry Van',
  '53_reefer' = 'Reefer',
  '48_reefer' = 'Reefer',
  '53_flatbed' = 'Flatbed',
  '48_flatbed' = 'Flatbed',
  'dry_van' = 'Dry Van',
  'reefer' = 'Reefer',
  'open_deck' = 'Flatbed',
  'container' = 'Container',
  'mixed_unspecified' = 'Mixed / Unspecified',
}
